import clsx from 'clsx';
import React, {useState} from 'react';
import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import StarRatings from 'react-star-ratings';
import {alertActions} from '../../../../_actions';
import NoProducts from '../../../../_components/NoProducts/NoProducts';
import {ReviewFormField} from '../../../../_components/ReviewFormField';
import {productService} from '../../../../_services/product.service';
import {Reviews} from './components/ReviewPanel/Reviews';
import {ReviewsRating} from './components/ReviewPanel/ReviewsRating';

export const TabPaneReview = ({productId}) => {
  const [rate, setRate] = useState(1);
  const [reviews, setReviews] = useState(null);
  const [rates, setRates] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploadReview, setUpLoadReview] = useState(false);
  const [error, setError] = useState(null);
  const [numberOfRatings, setNumberOfRatings] = useState(0);
  const [formState, setFormState] = useState({
    values: {
      feedback: '',
      benefits: '',
      disadvantages: '',
    },
  });
  const {t} = useTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    productService
      .getReviewById(productId)
      .then(res => {
        setLoading(true);
        return res;
      })
      .then(data => {
        setReviews(data.data.results.reviews);
        setRates(data.data.results.rate);
        setNumberOfRatings(data.data.results.number_of_ratings);
        setLoading(false);
      });
  }, []);

  const handleChange = event => {
    event.persist();
    setFormState(formState => ({
      ...formState,
      values: {...formState.values, [event.target.name]: event.target.value},
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    const objectToSand = {
      product_id: productId,
      rate,
      ...formState.values,
    };
    setUpLoadReview(true);
    productService
      .createReview(objectToSand)
      .then(() => {
        dispatch(alertActions.success(t('common:review_alert_text')));
      })
      .catch(err => {
        setError(err.message);
        dispatch(alertActions.error(err.message));
      })
      .finally(() => {
        setUpLoadReview(false);
        setRate(1);
        setFormState({
          values: {
            feedback: '',
            benefits: '',
            disadvantages: '',
          },
        });
      });
  };

  const starIconFill = index => {
    return (
      <svg
        key={index}
        onClick={() => setRate(index)}
        // onMouseMove={() => setRate(index)}
        // onMouseLeave={() => setRate(index)}
        style={{cursor: 'pointer'}}
        width="28"
        height="27"
        viewBox="0 0 28 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.9098 0.449724C13.1518 -0.0678285 13.9432 -0.136566 14.314 0.274126C14.407 0.382719 14.4648 0.516151 14.5289 0.643228C15.7465 3.1172 16.9665 5.59059 18.1887 8.0634C20.9792 8.46023 23.768 8.8715 26.5574 9.27642C26.9669 9.31512 27.3152 9.68653 27.3094 10.1007C27.3221 10.3618 27.1864 10.6061 26.9981 10.7777C25.0151 12.7035 23.0408 14.6385 21.0595 16.5655C20.959 16.6331 20.9971 16.7578 21.0087 16.8578C21.2831 18.4347 21.5493 20.0127 21.822 21.5902C22.0213 22.7016 22.1847 23.8199 22.4089 24.926C22.585 25.4205 22.1674 26.0073 21.6429 26.0045C21.3195 26.0362 21.0485 25.8358 20.7753 25.6972C18.4076 24.4506 16.0394 23.2053 13.6705 21.9599C11.1746 23.2717 8.67927 24.5841 6.18509 25.8982C5.8518 26.083 5.39374 26.0293 5.13959 25.7364C4.93857 25.5302 4.88947 25.2241 4.94377 24.9491C5.40529 22.2522 5.86624 19.5547 6.33238 16.8578C6.34278 16.7584 6.38264 16.6325 6.28097 16.5655C4.29048 14.6287 2.30518 12.6856 0.314103 10.7488C0.0108494 10.4808 -0.0648195 9.99267 0.166808 9.65592C0.306594 9.43411 0.554395 9.29837 0.812016 9.27006C3.5927 8.87093 6.37166 8.45792 9.15235 8.0634C10.4075 5.52647 11.6552 2.98665 12.9098 0.449724Z"
          fill="#FFBE00"
        />
      </svg>
    );
  };
  const starIconOutline = index => {
    return (
      <svg
        key={index}
        onClick={() => setRate(index)}
        // onMouseMove={() => setRate(index)}
        // onMouseLeave={() => setRate(index)}
        style={{cursor: 'pointer'}}
        width="28"
        height="26"
        viewBox="0 0 28 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.076 0.223106C13.4167 -0.0720598 13.9944 -0.0547649 14.3022 0.281333C14.4377 0.44794 14.5121 0.653173 14.6106 0.842264C15.7988 3.2451 16.9754 5.65486 18.1734 8.05308C20.8414 8.43818 23.5089 8.82905 26.1763 9.21415C26.4755 9.25681 26.8157 9.27526 27.033 9.5145C27.3581 9.82869 27.3478 10.3983 27.0186 10.7055C24.9997 12.6737 22.9831 14.6447 20.9619 16.6106C21.0766 17.4753 21.2519 18.332 21.3902 19.1933C21.66 20.7683 21.9304 22.3433 22.2002 23.9183C22.2608 24.2561 22.3051 24.5974 22.3922 24.93C22.5242 25.3757 22.1847 25.883 21.7292 25.951C21.5401 25.9764 21.3407 25.962 21.1689 25.8732C18.6646 24.5611 16.1666 23.2363 13.66 21.9288C11.3177 23.1498 8.98404 24.387 6.64519 25.6143C6.331 25.77 6.01969 26.0156 5.6467 25.955C5.18089 25.9101 4.84191 25.4177 4.9428 24.9646C5.3671 22.4482 5.80524 19.9341 6.233 17.4188C6.27854 17.1496 6.33734 16.8833 6.3581 16.6106C4.35477 14.6655 2.36182 12.7094 0.358495 10.7643C0.171134 10.5926 0.0345041 10.3493 0.0477635 10.0887C0.042575 9.68169 0.379249 9.31331 0.78222 9.26834C3.56958 8.86191 6.3581 8.45663 9.14661 8.05308C10.3567 5.62949 11.5466 3.19437 12.7468 0.765013C12.8443 0.578228 12.9157 0.367807 13.076 0.223106ZM10.4408 9.23721C10.3117 9.48568 10.0471 9.63153 9.77499 9.66209C7.41943 10.0005 5.06501 10.3475 2.70945 10.6854C3.38337 11.387 4.10054 12.0465 4.79118 12.7314C5.79832 13.7235 6.81756 14.703 7.82586 15.694C8.00803 15.8629 8.12852 16.1079 8.11929 16.3592C7.72209 18.7655 7.28107 21.1655 6.89712 23.5735C9.03535 22.4649 11.1597 21.3281 13.2962 20.216C13.5516 20.0794 13.8566 20.1128 14.1022 20.2535C16.2093 21.3598 18.3112 22.4759 20.4229 23.5735C20.3266 22.8587 20.1825 22.1502 20.0678 21.4382C19.7807 19.7612 19.493 18.0841 19.2053 16.4071C19.1529 16.0255 19.4359 15.7263 19.6982 15.4933C20.4742 14.7318 21.2577 13.9783 22.0336 13.2162C22.8863 12.3664 23.7718 11.549 24.6106 10.6859C22.255 10.3475 19.9006 10.0005 17.5444 9.66151C17.2729 9.63153 17.0077 9.4851 16.8792 9.23721C15.7942 7.0788 14.7525 4.89734 13.66 2.7424C12.567 4.89734 11.5258 7.0788 10.4408 9.23721Z"
          fill="#FFBE00"
        />
      </svg>
    );
  };

  return (
    <div className="row mt-4">
      {!loading ? (
        reviews && rates && numberOfRatings > 0 ? (
          <div className="col-lg-6 col-12">
            <ReviewsRating rates={rates} />
            <Reviews reviews={reviews} />
            {/* <button className="btn btn-show__more">
              {t('common:download_more')}
            </button> */}
          </div>
        ) : (
          <div className="col-lg-6 col-12">
            <NoProducts variant="noReviews" />
          </div>
        )
      ) : (
        <div className="col-lg-6 col-12">{t('common:loading')}</div>
      )}

      <div className="col-lg-6 col-12">
        <form onSubmit={handleSubmit} className="single-product__form">
          <h3 className="single-product__form-title">
            {t('common:add_review')}
          </h3>
          <ReviewFormField
            onChangeState={handleChange}
            formState={formState}
            name="feedback"
            title={t('common:your_feedback')}
            type="textarea"
          />
          <ReviewFormField
            onChangeState={handleChange}
            formState={formState}
            name="benefits"
            title={t('common:benefits')}
            type="input"
          />
          <ReviewFormField
            onChangeState={handleChange}
            formState={formState}
            name="disadvantages"
            title={t('common:disadvantages')}
            type="input"
          />
          <div className="single-product__form-footer">
            <div>
              <div className="rating-title">{t('common:rate_the_product')}</div>
              <div className="d-flex items-center gap-10 mt-2">
                {[...new Array(5)].map((arr, index) =>
                  index < rate
                    ? starIconFill(index + 1)
                    : starIconOutline(index + 1),
                )}
              </div>
            </div>
            <button
              className={clsx('btn btn-big', uploadReview ? 'disabled' : '')}>
              {!uploadReview ? t('common:add_review') : t('common:loading')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
